export const MAXIMUM_NUMBER_OF_SELECTED_OPTIONS = 100;
